import Vue from 'vue';
import moment from 'moment';
import FormButton from './components/shared/FormButton.vue';
import BlumarDecimalInput from './components/shared/BlumarDecimalInput.vue';
import Multiselect from "vue-multiselect";
import BlumarMultiselect from 'blumar/components/shared/BlumarMultiSelect.vue';
import LabeledInput from 'blumar/components/shared/LabeledInput.vue';
import LabeledSelect from 'blumar/components/shared/LabeledSelect.vue';


Vue.component('form-button', FormButton);
Vue.component('blumar-decimal-input', BlumarDecimalInput);
Vue.component('multiselect', Multiselect);
Vue.component('blumar-multiselect', BlumarMultiselect);
Vue.component('labeled-input', LabeledInput)
Vue.component('labeled-select', LabeledSelect);

Vue.filter('date', function(value) {
	if (value) {
	  return moment(String(value)).format('DD/MM/YYYY');
	}
});

Vue.filter('datetime', function(value) {
	if (value) {
	  return moment(String(value)).format('DD/MM/YYYY hh:mm');
	}
});

Vue.filter('number', function(value) {
	return value.toString().replace(/,/g, '!').replace(/\./g, ',').replace(/!/g, '.');
});



// WEBPACK FOOTER //
// ./src/components.js